var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.push !== undefined)?_c('v-switch',{staticClass:"push",attrs:{"hide-details":""},model:{value:(_vm.push),callback:function ($$v) {_vm.push=$$v},expression:"push"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }